export const CRYPTO_JS = {
    // aesSecret:
    //     'c639a2a6d722f362447fc5622e0c7dda049959f6499d5ffc573122d1b4664837',
    // aesIV: '$2y$12$BjHHsZts8Z2JOGhgBHcboO5Zhz0NWwVm7WHlnKTP5KB0.YCDuCo/m',
    aesSecret: 'BMA-TAXMAP-4383480-457904-257984',
    aesIV: 'BMA-TAXMAP-76930',
    aesBlockSize: 128,
};